import { usePersonalization } from './usePersonalization';

export const useDashboardPersonalization = () => {
  const { config, profile, isLoading } = usePersonalization();


  const getWelcomeMessage = () => {
    const name = profile?.first_name ? `, ${profile.first_name}` : '';
    
    switch (config.primaryFocus) {
      case 'weight_loss':
        return `Welcome back${name}! Let's track your weight loss progress.`;
      case 'muscle_gain':
        return `Welcome back${name}! Time to build some muscle.`;
      case 'endurance':
        return `Welcome back${name}! Ready to boost your endurance?`;
      case 'marathon':
        return `Welcome back${name}! Your marathon journey continues.`;
      case 'body_composition':
        return `Welcome back${name}! Let's analyze your body composition.`;
      default:
        return `Welcome back${name}! Here's your fitness overview.`;
    }
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return {
    config,
    profile,
    isLoading,
    getWelcomeMessage,
    formatTime,
  };
};